export default "__VITE_ASSET__CdJPjbDM__"